import type { UserEditSchemaEditPayload } from '@repo/schemas/user/userEdit';
import type { UserPrivate } from '@repo/types/users';

import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';
import { ParentKey } from '#parent/keys';

import { UserKey } from './keys';
import { UserService } from './userService';

export function useEditUser() {
  const queryClient = useQueryClient();
  const editUserMutation = useMutation({
    mutationFn: (data: UserEditSchemaEditPayload) => UserService.editUser(data).then((response) => response.data),
    onSuccess: (data) => {
      queryClient.setQueryData([UserKey.USERS, data.id], (curr: UserPrivate) => {
        return { ...curr, ...data };
      });
      queryClient.setQueryData([UserKey.USERS], (curr?: UserPrivate[]) => {
        if (curr) {
          return curr.map((u) => (u.id === data.id ? data : u));
        }
        return [data];
      });
      queryClient.invalidateQueries({ queryKey: [UserKey.USERS, data.id] });
      queryClient.invalidateQueries({ queryKey: [UserKey.USERS] });
      queryClient.invalidateQueries({ queryKey: [ParentKey.PARENTS] });
    },
  });

  const errorMessage = useErrorMessage(editUserMutation.error, baseErrorMessages);

  return {
    ...editUserMutation,
    errorMessage,
  };
}
